module.exports = {"bewizr-agenda":{"empty":{"title":"Nessuna attività","detail":"Non hai attività pianificate."}}}